// This file is automatically generated. Do not edit manually.

import { Supplier } from "src/api/generated/erp/db/types/tables/supplier";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PurchaseOrderSupplierChangeApi {
	export async function getSupplierOptionsForSupplierChange(args: {
		purchaseOrderId: number;
	}): Promise<Array<Supplier>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/getSupplierOptionsForSupplierChange",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as Array<Supplier>;
	}

	export async function changePurchaseOrderSupplier(args: {
		purchaseOrderId: number;
		newSupplierId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/changePurchaseOrderSupplier",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				newSupplierId: args.newSupplierId,
			},
		});
		return response as void;
	}
}
